import { TeamModel } from '@modules/team/team-model';

const { fields } = TeamModel;

export default [
  fields.id,
  fields.name,
  fields.createdAt
];
